<template>
  <sn-combobox
    :ref="assignDropdownRef"
    v-model="selectedMersOrgs"
    placeholder="Select org IDs this user can access"
    multiple
    attach
    :disabled="disabled"
    :items="mersOrgs"
    item-text="displayName"
    @change="onSelectionChange"
    @mouseup="handleMouseup"
  >
    <template
      v-slot:selection="{item, parent}"
    >
      <v-chip
        :key="item.key"
        :class="reportFilterClass"
        :close="!disabled"
        close-icon="sn-icon-exit-circle"
        color="#F3F5F7"
        @click:close="parent.selectItem(item)"
      >
        <span
          class="sn-text-primary"
          :class="reportFilterChipTextClass"
        >{{ displayName(item) }}</span>
      </v-chip>
    </template>
    <template
      v-slot:item="data"
    >
      <v-icon
        v-if="selectedOrgGuids.includes(data.item.guid)"
        style="margin-right: 12px"
        color="#22A969"
      >
        sn-icon-check
      </v-icon>
      <span class="item-font">{{ displayName(data.item) }}</span>
    </template>
    <template v-slot:append-outer>
      <sn-btn
        v-if="showRemoveButton"
        size="standard"
        icon
        icon-btn="$snMinusCircle"
        @click="$emit('remove-filter')"
      />
    </template>
  </sn-combobox>
</template>

<script>
import dropdownsPositioningMixin from '../mixins/dropdownsPositioningMixin'

export default {
  name: 'MersOrgCombobox',
  mixins: [dropdownsPositioningMixin],
  props: {
    mersOrgs: {
      type: Array,
      default: () => [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: '',
      required: false
    },
    showRemoveButton: {
      type: Boolean,
      default: false,
      required: false
    },
    assignDropdownRef: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      selectedMersOrgs: []
    }
  },
  computed: {
    selectedOrgGuids () {
      return this.selectedMersOrgs.map(o => o.guid)
    },
    reportFilterClass () {
      return this.showRemoveButton ? 'report-filter-chip' : ''
    },
    reportFilterChipTextClass () {
      return this.showRemoveButton ? 'py-1' : ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        this.selectedMersOrgs = newVal
      }
    }
  },
  created () {
    this.selectedMersOrgs = this.value
  },
  methods: {
    handleMouseup (event) {
      event.stopPropagation()
      this.positionMenuDropdown()
    },
    onSelectionChange (items) {
      const updatedSelection = []

      // Loop through the new selection array
      items.forEach((item) => {
        const existingItemIndex = updatedSelection.findIndex((org) => org.guid === item.guid)

        if (existingItemIndex === -1) {
          // Item is not already in the updated selection, so add it
          updatedSelection.push(item)
        } else {
          // Item is already in the updated selection, so remove it (deselect)
          updatedSelection.splice(existingItemIndex, 1)
        }
      })
      // Emit the updated selection back to the parent
      this.$emit('input', updatedSelection)
    },
    displayName (org) {
      if (org.active) {
        return org.displayName
      } else {
        return `${org.displayName} - inactive`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';
@import '~/assets/css/evui';
.item-font {
  font-family: "Open Sans", sans-serif !important;
}

.report-filter-chip {
  word-wrap: break-word;
  white-space: normal;
  height: auto;
  max-width: 350px;
}

::v-deep .v-autocomplete {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .v-input__append-outer {
    display: none;
  }

  &:hover .v-input__append-outer {
    display: block;
  }
}
</style>
